<template>
    <div>
        <!-- Tìm kiếm -->
        <div class="col-md-12 form-row pt-2">
            <div class="d-flex col-md-4">
                <Label text="Tên phương thức thanh toán:" />
                <el-input placeholder="Nhập tên phương thức thanh toán"  v-model="search.cTenPhuongThuc"/>
            </div>
            <div class="d-flex col-md-4">
                <Label text="Trạng thái:" />
                <el-select placeholder="Chọn trạng thái" v-model="search.nTinhTrang">
                    <el-option label="Tất cả" value="5"></el-option>
                    <el-option label="Bình thường" value="1"></el-option>
                    <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
            </div>
                <el-button type="primary" native-type="submit" style="margin-left: 5px" :loading="isSearchLoading"
                    @click="handleSearch">
                    <span class="btn-inner--icon"><i class="fas fa-search"></i></span>
                    <span class="btn-inner--text">&nbsp;Tìm kiếm</span>
                </el-button>
        </div>
        <el-card class="box-card">
            <div slot="header" class="el-card-header">
                <div style="padding: 5px 10px" class="form-row">
                    <div class="col-md-6">
                        <el-button type="primary" outline native-type="submit" @click="handleOpenAdd">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm phương thức thanh toán</span>
                        </el-button>
                    </div>
                    <div class="col-md-6" style="text-align:right">
                        <el-button plain icon="el-icon-refresh"  style="margin-right:30px" title="Đồng bộ" type="warning"
                            @click="" v-loading.fullscreen.lock="isLoading"></el-button>
                        <!-- <el-button plain icon="el-icon-s-grid" ></el-button> -->
                    </div>
                </div>
            </div>
            <div class="col-md-12 tbl">
                <el-table :data="tableData.content" header-row-class-name="thead-light" :border="true" 
                    style="height: 100%" height="100%" fit stripe highlight-current-row>
                    <el-table-column prop="" type="index" label="STT" width="120"></el-table-column>
                    <el-table-column prop="c_ten_phuong_thuc_thanh_toan" label="Tên sản phẩm" min-width="150"></el-table-column>
                    <el-table-column prop="d_ngay_tao" label="Ngày tạo" width="120">
                        <template #default="scope">
                            <span v-if="scope.row.d_ngay_tao">{{
                                moment(scope.row.d_ngay_tao).format("DD/MM/YYYY")
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="n_tinh_trang" label="Trạng thái" width="120" align="center">
                        <template #default="scope">
                            <el-tag type="success" v-if="scope.row.n_tinh_trang == 1" :size="size">Hoạt Động</el-tag>
                            <el-tag type="danger" v-if="scope.row.n_tinh_trang == 0" :size="size">Đã xóa</el-tag>
                        </template>
                    </el-table-column>
                    <!-- Button hành động -->
                    <el-table-column width="160" align="center">
                        <template #default="scope">
                            <el-button type="primary" @click="handleOpenEdit(scope.row)"
                                :disabled="scope.row.n_tinh_trang == 0">
                                <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                                <span class="btn-inner--text">&nbsp;Sửa</span>
                            </el-button>

                            <el-button type="danger" @click="handleDelete(scope.row)"
                                :disabled="scope.row.n_tinh_trang == 0" v-loading.fullscreen.lock="isLoading">
                                <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                <span class="btn-inner--text">&nbsp;Xóa</span>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum" :current-page.sync="tableData.pageNum"
                    :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
                </el-pagination>
            </div>
        </el-card>
        <el-dialog v-model="centerDialogVisible" class="modalTemp" dataBackDrop="static">
            <h6 slot="header" class="modal-title" v-if="!operation">
                Thêm phương thức thanh toán
            </h6>
            <h6 slot="header" class="modal-title" v-if="operation">
                Cập nhật phương thức thanh toán
            </h6>
            <el-form :model="validateForm" :rules="rules" ref="validateForm" label-width="150px" class="demo-ruleForm"
                >
                <div class="row">
                    <div class="col-sm">
                        <el-form-item label="Chi tiết" prop="cTenPhuongThuc">
                            <el-input :size="size" v-model="validateForm.cTenPhuongThuc"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <template slot="footer">
                <el-button v-if="!operation" type="primary" @click="handleAdd()"
                    v-loading.fullscreen.lock="isLoading">Thêm</el-button>
                <el-button v-if="operation" type="primary" @click="handleEdit()"
                    v-loading.fullscreen.lock="isLoading">Lưu</el-button>
                <el-button outline type="danger" @click="handleClose">Thoát</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";

export default {
    data() {
        return {
            size: "",
            tableData: {
                content: [
                ]
            },
            search: {
                cTenPhuongThuc:"",
                nTinhTrang:"5"
            },
            isSearchLoading: false,
            isLoading: false,
            centerDialogVisible: false,
            operation: false,
            validateForm: {
                cTenPhuongThuc:""
            },
            rules: {
                cTenPhuongThuc: [
                    { required: true, message: "Xin vui lòng nhập tên phương thức", trigger: "blur", },
                ],
            },
            productList: [],
            fit: "cover",
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },
            selected: {},
        };
    },
    methods: {


        handleFindPage() {
            this.isSearchLoading = true
            this.pageRequest.columnFilters={
                cTenPhuongThuc:{value:this.search.cTenPhuongThuc},
                nTinhTrang:{value:this.search.nTinhTrang}
            }
            this.$api.payment.findPagePaymentMethod(this.pageRequest).then(res =>{
                if(res.code == 200 ){
                    this.tableData = res.data
                    this.isSearchLoading = false
                }else{
                    ElMessage({message:"Có lỗi xảy ra xin vui lòng thử lại sau", type:"error"})
                    this.isSearchLoading = false
                }
            })
        },
        handleOpenAdd() {
            this.validateForm = {
                cTenPhuongThuc:"",
            }
            this.operation = false
            this.centerDialogVisible = true
        },
        handleAdd() {
            this.$refs.validateForm.validate((valid) => {
                if (valid) {
                    let pageRequest = {
                        columnFilters:{
                            cTenPhuongThuc:{value:this.validateForm.cTenPhuongThuc},
                        }
                    }
                    this.$api.payment.insertPaymentMethod(pageRequest).then(res =>{
                        if(res.code == 200){
                            ElMessage({ message: res.msg, type: "success" })
                            this.centerDialogVisible = false
                            this.handleSearch()
                        }else{
                            ElMessage({ message: res.msg, type: "error" })
                            this.centerDialogVisible = false
                        }
                    })
                }
            })

        },
        handleOpenEdit(val) {
            this.selected = Object.assign({},val)
            this.validateForm={
                cTenPhuongThuc:this.selected.c_ten_phuong_thuc_thanh_toan,
            }
            this.operation = true
            this.centerDialogVisible = true
        },
        handleEdit() {
            this.$refs.validateForm.validate((valid) => {
                if (valid) {
                    let pageRequest = {
                        columnFilters:{
                            cTenPhuongThuc:{value:this.validateForm.cTenPhuongThuc},
                            nMaPhuongThuc:{value:this.selected.n_ma_phuong_thuc_thanh_toan},
                        }
                    }
                    this.$api.payment.updatePaymentMethod(pageRequest).then(res =>{
                        if(res.code == 200){
                            ElMessage({ message: res.msg, type: "success" })
                            this.handleSearch()
                            this.centerDialogVisible = false
                        }else{
                            ElMessage({ message: res.msg, type: "error" })
                            this.centerDialogVisible = false
                        }
                    })
                }

            })
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa phương thức này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    let pageRequest = {
                        columnFilters:{
                            nMaPhuongThuc:{value:val.n_ma_phuong_thuc_thanh_toan},
                        }
                    }
                    this.$api.payment.deletePaymentMethod(pageRequest).then(res =>{
                        if(res.code == 200){
                            ElMessage({ message: res.msg, type: "success" })
                            this.handleSearch()
                            this.centerDialogVisible = false
                        }else{
                            ElMessage({ message: res.msg, type: "error" })
                            this.centerDialogVisible = false
                        }
                    })
                })
        },
        handleSearch(){
            this.pageRequest.pageNum = 1
            this.handleFindPage()
        },
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleClose() {
            this.centerDialogVisible = false
        }
    },
    mounted() {
        this.handleFindPage()

    },
};
</script>
<style lang="scss" scoped>
.tbl {
    height: calc(100vh - 255px);
}

.box-card {
    margin: 10px;
}
</style>